import { jwtDecode } from 'jwt-decode';
import {
  LOGIN,
  VALIDATE,
  CHECK_TOKEN,
  LOGOUT,
  CREATE_USER,
  SET_AUTH_STATE
} from '../actions/types';
//import { cookies } from '../sessions/public';

const INITIAL_STATE = {
  status: 0,
  profile: {},
  authenticated: false,
  error: null
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VALIDATE: {
      if (action.payload.status === 200) {
        const { token, email } = action.payload;
        //cookies.createCookie('token', token, 7);
        const { salt, sessionId } = (token) ? jwtDecode(token) : {};
        console.log({ salt, sessionId });
        return {
          ...state,
          login: action.payload.message
        };
      }

      return { ...state, message: 'Network error' };
    }
    case CHECK_TOKEN: {
      const { payload = {} } = action;
      const { data = {} } = payload || {};
      const { profile } = data.message || {};
      // console.log(data);
      if (data.auth === true) {
        return { ...state, status: 1, profile };
      }
      return state;
    }
    case LOGOUT: {
      return { ...INITIAL_STATE };
    }
    case CREATE_USER:
    case LOGIN: {
      // action.payload.setDataValue('status',0);
      if (action.payload.success === true) {
        const token = action.payload.token;
        const tokenDecoded = (token) ? jwtDecode(token) : {};
        console.log('authReducer return', {
          ...state,
          status: 1,
          profile: { ...tokenDecoded, token },
          authenticated: true,
          error: null,
        });
        return {
          ...state,
          status: 1,
          profile: { ...tokenDecoded, token },
          authenticated: true,
          error: null,
        };
      } else if (action.payload.success === false) {
        return {
          ...state,
          status: 1,
          profile: {},
          error: action.payload.error || 'Authentication error'
        };
      }
      return { ...state, message: action.payload.message };
    }
    case SET_AUTH_STATE: {
      return { ...state, authenticated: action.payload?.authenticated };
    }
    default:
      return state;
  }
};

export default authReducer;
